import React from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'utils/mixpanel/mixpanel';

import Codebook, { START_LOADING, FINISH_LOADING } from 'ff-vis-js/dist/Codebook';

import CodebookElements from './CodebookElements';
import CodebookContainer from './CodebookContainer';

class CodebookPane extends React.Component {
  constructor(props) {
    super(props);

    const url = window.location.href;
    const params = new URLSearchParams(new URL(url).search);
    const query = params.get('query');

    this.state = {
      searchInput: query ? decodeURIComponent(query) : '',
    };

    let className = null;
    do {
      // Random number. Remove leading '0.'. Prefix CB- to make valid class name
      className = `CB-${Math.random().toString().slice(2)}`;
    } while (document.querySelector(`.${className}`));

    this.className = className;
  }

  componentDidMount() {
    const {
      onGenerateCdf,
      setLoading,
    } = this.props;

    this.codebook = new Codebook(
      ({ CDF, Metadata }) => onGenerateCdf(CDF, Metadata),
      { selector: `.${this.className}` },
      (event) => {
        switch (event.type) {
          case START_LOADING:
            setLoading(true);
            break;
          case FINISH_LOADING:
            // Ignore event
            // This loading state is cleaned up when the onGenerateCdf method finishes
            break;
          default:
            // Ignore event
        }
      },
      (getEventReport) => {
        const eventReport = getEventReport.params;
        const level2 = eventReport.themes.level2;
        const level3 = eventReport.themes.level3;

        const levelTwoTopics = level2 === null ? [] : level2.map((obj) => {
          const [topicId, topicName] = Object.entries(obj)[0];
          return { topic_id: topicId, topic_name: topicName };
        });

        const topicsWithSubs = level3 === null ? [] : level3.reduce((acc, obj) => {
          const [key, subTopicName] = Object.entries(obj).find(([key, _]) => key !== 'parent');
          const [parentId, subTopicId] = key.split('_');
          const topicName = obj.parent;

          if (!acc[parentId]) {
            acc[parentId] = { topic_id: parentId, topic_name: topicName, subtopics: [] };
          }
          acc[parentId].subtopics.push({ subtopic_id: subTopicId, subtopic_name: subTopicName });

          return acc;
        }, {});

        const levelThreeTopics = Object.values(topicsWithSubs);
        const topicFilters = levelTwoTopics.concat(levelThreeTopics);

        const query = eventReport.search.searchString === '' ? null : eventReport.search.searchString;
        mixpanel.track('Search data tool', {
          chart_search_query: query,
          chart_search_topic_filter: topicFilters,
          chart_search_years_filter: eventReport.filters.years,
          chart_search_age_filter: eventReport.filters.adultKids,
        });
      }
    );
  }

  onInputChange = (value) => {
    this.setState({ searchInput: value });
  }

  render() {
    return (
      <CodebookContainer className={this.className}>
        <CodebookElements
          searchInput={this.state.searchInput}
          onInputChange={this.onInputChange}
        />
      </CodebookContainer>
    );
  }
}

CodebookPane.propTypes = {
  onGenerateCdf: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default CodebookPane;



// WEBPACK FOOTER //
// ./app/containers/Codebook/index.js